import classNames from "classnames";
import type { ReactNode } from "react";

import lineWaveMessenger from "../../assets/line-wave-messenger.svg";

type ChatWaveBackgroundProps = {
  children: ReactNode;
  className?: string;
};

export default function ChatWaveBackground({
  children,
  className,
}: ChatWaveBackgroundProps) {
  return (
    <div
      className={classNames(
        "relative flex min-h-0 flex-1 flex-col bg-gray-50",
        className,
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-size-[262px_360px] bg-repeat"
        style={{ backgroundImage: `url(${lineWaveMessenger})` }}
      />
      <div className="relative flex min-h-0 flex-1 flex-col">{children}</div>
    </div>
  );
}
